module.exports = __webpack_public_path__ + "img/website-dark.3ae915ad.png";